var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-1200 template"},[_c('left-nav',{attrs:{"navList":_vm.navList}}),_c('div',{staticClass:"right-sidebar"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }